import { get } from "./BaseFunctions";

const getInsectsOfAField = (companyId, fieldTypeId) => {
  return get(
    `insect/get-inscets-of-a-field?companyId=${companyId}&fieldTypeId=${fieldTypeId}`
  );
};

export { getInsectsOfAField };
